<template>
  <div class="login-page">
    <div class="login-stack">
      <div class="text-center mb-8">
        <HeaderLogo />
      </div>

      <v-form>
        <v-row>
          <v-text-field v-model.trim="username" name="Username" persistent-placeholder :placeholder="$t('Login.Username')"/>
        </v-row>
        <v-row>
          <v-text-field v-model.trim="password" name="Password" persistent-placeholder :placeholder="$t('Login.Password')" type="password" @keyup.enter="submit"/>
        </v-row>

        <v-row>
          <div v-if="loginFailed" class="red--text mb-2">
            {{ errorMessage ||  $t('Login.YourUsernameOrPasswordIsIncorrect') }}
          </div>
          <div v-if="facilityLoginFailed" class="red--text mb-2 text-left">
            {{ $t('Login.YourAreNotAssignedToAnyFacilityPleaseContactSupport') }}
            <a href="mailto:support@getreshub.com">support@getreshub.com</a> {{ $t('Login.ClickToGetAssistance') }}
          </div>
          <div v-if="maintenanceUserFailed" class="red--text mb-2 text-left">
            {{ $t('Login.YouHaveInsufficientPermissionsToLogIntoStaffHub') }}
          </div>
          <div v-if="rciUserFailed" class="red--text mb-2 text-left">
            {{ $t('Login.NotActiveOnMCare') }}
          </div>
        </v-row>

        <v-row class="py-3">
          <p class="text-center w-100">
            <router-link class="black--text font-weight-bold text-decoration-none" to="/login/forgot-password">
              {{$t('Login.ForgotPasswordQuestion')}}
            </router-link>
          </p>
        </v-row>

        <v-row>
          <v-btn block class="primary" large
                 @click="submit"
                 :disabled="loading || pcsLoading"
                 :loading="loading">
            {{$t('Login.SignIn')}}
          </v-btn>

          <v-btn block class="primary mt-4 d-none" large
                 to="/pcs-auth-login"
                 :disabled="loading || pcsLoading">
            {{$t('Login.SignInWithPcs')}}
          </v-btn>

          <!-- <v-btn block class="primary mt-4" large
                 @click="startPcsLogin"
                 :disabled="loading || pcsLoading"
                 :loading="pcsLoading">
            {{$t('PcsLogin.SignIn')}}
          </v-btn> -->
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderLogo from "@/views/login/HeaderLogo.vue";
import { generatePkce } from "@/utils/pcsAuth/pkce";
import { getFunctionUrl, getPcsAuthorizeUrl } from "@/utils/pcsAuth/pcsAuthUrls";

export default {
  components: {
    HeaderLogo
  },
  data() {
    return {
      username: "",
      password: "",
      error: null,
      loading: false,
      pcsLoading: false
    };
  },
  computed: {
    ...mapState({
      facilityLoginFailed: state => state.authModule.facilityLoginFailed,
      loginFailed: state => state.authModule.loginFailed,
      maintenanceUserFailed: state => state.authModule.maintenanceUserFailed,
      rciUserFailed: state => state.authModule.rciUserFailed,
      errorMessage: state => state.authModule.error
    })
  },
  created() {
    this.$store.dispatch("resetFailures");
  },
  methods: {
    submit() {
      this.loading = true;
      this.$store.dispatch("userSignIn", {
        email: this.username.trim(),
        password: this.password.trim()
      }).then((isSuccess) => {
        if (isSuccess === false && this.loginFailed) {
          throw new Error(this.$t('Login.LoginFaildForUser') + ' '+ this.username);
        }
        else if (isSuccess === false && this.facilityLoginFailed) {
          throw new Error(this.$t('Login.NoAnyFacilityAssigned') + ' ' + this.username);
        }

      }).finally(()=>{
        this.loading = false;
      })
    },
    async startPcsLogin () {
    this.pcsLoading = true;
     const { codeVerifier, codeChallenge, state } = await generatePkce();

      // Save codeVerifier to Firestore via backend
      const codeverifierFuncUrl = getFunctionUrl('pcs-codeverifier')
      await fetch(codeverifierFuncUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ state, codeVerifier }),
      });

      //Redirect to PCS Identity login
      const pcsAuthFuncUrl = getFunctionUrl('pcs-auth')
      const authUrl = new URL(getPcsAuthorizeUrl());
      authUrl.searchParams.set('client_id', 'ResHubCarePlan');
      authUrl.searchParams.set('response_type', 'code');
      authUrl.searchParams.set('redirect_uri', pcsAuthFuncUrl);
      authUrl.searchParams.set('scope', 'openid PCSClaim profile');
      authUrl.searchParams.set('code_challenge', codeChallenge);
      authUrl.searchParams.set('code_challenge_method', 'S256');
      authUrl.searchParams.set('state', state);
      this.pcsLoading = false;
      window.location.href = authUrl.toString();
    }
  }
};
</script>


<style scoped>
:global(html), 
:global(body), 
:global(#app), 
:global(.v-application), 
:global(.v-application--wrap) {
  height: 100%;
  margin: 0;
  overflow: hidden;
}

.login-page {
  position: fixed;
  inset: 0;               
  display: grid;
  place-items: center; 
  padding: env(safe-area-inset-top) env(safe-area-inset-right)
           env(safe-area-inset-bottom) env(safe-area-inset-left);
  box-sizing: border-box;
}

.login-stack {
  width: 100%;
  max-width: 480px;
  padding: 16px;
  box-sizing: border-box;
}

@media (max-height: 520px) {
  .login-page { overflow: auto; }
}
</style>
